module.exports = new __parcel__URL__("OKR Tracking.3e82c60a.svg").toString();